import { connect } from 'react-redux';
import { AppState } from '../../../../../types/store';
import { GallectionSourceType } from '../../../../../types/gallection';
import { getModuleData } from '../../../../selectors/modules';
import {
  getProfileOwnerUser,
  isCurrentUserProfileOwner,
} from '../../../../selectors/users';

export interface ConnectedProps {
  isOwner?: boolean;
  username?: string;
  sourceType: GallectionSourceType;
}

export default connect(
  (state: AppState, ownProps) => {
    return {
      isOwner: isCurrentUserProfileOwner(state),
      username: getProfileOwnerUser(state).username,
      sourceType: getModuleData(state, ownProps.moduleId).sourceType,
    };
  },
  {}
);
